import { openBlock as t, createElementBlock as o, createElementVNode as s } from "vue";
/* empty css                    */
import r from "./design-system.es128.js";
const a = {
  name: "DsPulseGraphic",
  compatConfig: { MODE: 3 }
}, c = { class: "pulse-graphic" };
function n(p, e, i, l, d, m) {
  return t(), o("div", c, e[0] || (e[0] = [
    s("div", { class: "animated-pulse" }, null, -1)
  ]));
}
const $ = /* @__PURE__ */ r(a, [["render", n], ["__scopeId", "data-v-5971849f"]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es345.js.map
